import { useRef } from "react";
import Tabs from "../../../../../shared/components/Tabs";
import DepositFundsConfirmation from "../components/DepositFundsConfirmation";
import DepositFundsCrypto, {
  type DepositCryptoSelection,
} from "../components/DepositFundsCrypto";
import DepositFundsEnterAmount from "../components/DepositFundsEnterAmount";
import DepositFundsFiat, {
  type DepositFundsFiatType,
} from "../components/DepositFundsFiat";
import DepositFundsCreditCardPayment from "../components/DepositFundsCreditCardPayment";
import DepositFundsBankDetail from "../components/DepositFundsBankDetail";
import { useDrawer } from "../../../hooks/useDrawer";
import type { IDrawerContent } from "../../../interfaces/drawer.interface";

export function useDepositDrawerRoute() {
  const { setActiveContent, onClose } = useDrawer();
  const cryptoSelectionRef = useRef<DepositCryptoSelection | null>(null);

  function showFundsDrawer() {
    setActiveContent(buildDrawerFundsHome());
  }

  function buildDepositFundsCryptoConfirmation(): IDrawerContent {
    return {
      title: "",
      element: (
        <DepositFundsConfirmation selection={cryptoSelectionRef.current} />
      ),
      onBackPressed: () => {
        setActiveContent(buildDrawerFundsHome());
      },
    };
  }

  function buildDepositFundsBankTranferEnterAmount(): IDrawerContent {
    return {
      title: "Bank Transfer",
      element: (
        <DepositFundsEnterAmount
          onSubmit={() => {
            setActiveContent(buildDepositFundsBankDetail());
          }}
        />
      ),
      onBackPressed: () => {
        setActiveContent(buildDrawerFundsHome());
      },
    };
  }

  function buildDepositFundsBankDetail(): IDrawerContent {
    return {
      title: "",
      element: (
        <DepositFundsBankDetail
          onSubmit={() => {
            setActiveContent(null);
          }}
        />
      ),
      onBackPressed: () => {
        setActiveContent(buildDepositFundsBankTranferEnterAmount());
      },
    };
  }

  function buildDepositFundsCreditCardEnterAmount(): IDrawerContent {
    return {
      title: "Deposit Via Card",
      element: (
        <DepositFundsEnterAmount
          onSubmit={() => {
            setActiveContent(buildDepositFundsCreditCardPayment());
          }}
        />
      ),
      onBackPressed: () => {
        setActiveContent(buildDrawerFundsHome());
      },
    };
  }

  function buildDepositFundsCreditCardPayment(): IDrawerContent {
    return {
      title: "Card Payment",
      element: (
        <DepositFundsCreditCardPayment
          onSubmit={() => {
            //TODO: show popup
          }}
          onCancel={() => {
            setActiveContent(buildDepositFundsBankTranferEnterAmount());
          }}
        />
      ),
      onBackPressed: () => {
        setActiveContent(buildDepositFundsCreditCardEnterAmount());
      },
    };
  }

  function createDepositFundsTabs() {
    return [
      {
        label: "Crypto",
        element: (
          <DepositFundsCrypto
            onSubmit={(selection) => {
              cryptoSelectionRef.current = selection;
              setActiveContent(buildDepositFundsCryptoConfirmation());
            }}
          />
        ),
      },
      {
        label: "Fiat",
        element: (
          <DepositFundsFiat
            onSubmit={(method: DepositFundsFiatType) => {
              if (method === "BankTransfer") {
                setActiveContent(buildDepositFundsBankTranferEnterAmount());
              }
              if (method === "CreditCard") {
                setActiveContent(buildDepositFundsCreditCardEnterAmount());
              }
            }}
          />
        ),
      },
    ];
  }

  function buildDrawerFundsHome(): IDrawerContent {
    return {
      title: "Deposit Funds",
      element: <Tabs tabs={createDepositFundsTabs()} />,
    };
  }

  function buildDirectBankDepositDrawer(
    onBackPressed?: () => void
  ): IDrawerContent {
    return {
      title: "Top Up via Bank Transfer",
      element: (
        <DepositFundsBankDetail
          onSubmit={() => {
            onClose();
          }}
        />
      ),
      onBackPressed,
    };
  }

  function showFiatBankDepositDrawer(onBackPressed?: () => void) {
    // Directly show bank details in a standalone drawer
    setActiveContent(buildDirectBankDepositDrawer(onBackPressed));
  }

  return {
    showFundsDrawer,
    showFiatBankDepositDrawer,
  };
}
